
import respUtility from '@/mixins/respUtility';
import routeMixin from '@/mixins/routeMixin';

export default {
  name: 'ListingHeaderPanel',
  mixins: [respUtility, routeMixin],
  props: {
    desktopFiltersVisible: {
      type: Boolean,
      default: false,
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    isBreadcrumbsEmpty() {
      return !this.$store.state.metaData?.addons?.breadcrumbs.length;
    },
    isTitleVisible() {
      return !(this.attrs.isBrandPage || this.attrs.isCollectionPage);
      // return !(this.$device.isMobileOrTablet || this.isTouchDevice) && !this.attrs.isCollectionPage;
    },
  },
  methods: {
    toggleDesktopFilters() {
      this.$emit('toggle-desktop-filters');
    },
  },
};
